module.exports = __webpack_public_path__ + "img/open_in_browser.924fa3ea.png";